<div class="prompt-container">
  <div class="prompt-header">
    <h1 class="prompt-title"><span class="accent-text">Describe</span> your AI Agent & Software</h1>
  </div>

  <div class="input-section">
    <textarea nz-input
              [(ngModel)]="inputText"
              placeholder="What do you want your agent to do?"
              class="prompt-textarea"
              [nzAutosize]="{ minRows: 8, maxRows: 30 }"
              (keypress)="onKeyPress($event)">
    </textarea>

    <div class="button-container">
      <button nz-button
              nzType="primary"
              class="start-button"
              (click)="onStart()">
        <i nz-icon
           nzType="play-circle"
           nzTheme="outline"></i>
        Start ⌘+↵
      </button>
    </div>
  </div>
  <p class="prompt-title">
    Start by describing your AI agent’s purpose in detail. For example:
  </p>
    <p class="prompt-description">“I want to create an AI agent that reads my Google spreadsheet, investigates each contact listed by searching the internet, and compiles a list of updates for my review. Once approved, the agent should update the Google spreadsheet, sync the data to Salesforce leads, and generate a summary report.”</p>
    <p class="prompt-title">Tips for Best Results:</p>
    <ul class="prompt-description-secondary">
      <li><b>Be specific:</b> Detailed instructions yield better outcomes.</li>
      <li><b>Customizable workflow:</b> Rapider generates an AI agent with a web app to manage data.</li>
      <li><b>Low-code flexibility:</b> Further tailor the agent and application using Rapider’s Low-Code platform.</li>
    </ul>

  <div class="options-container">
    <div class="option-buttons">
      <!-- <button nz-button
              class="option-button">
        <i nz-icon
           nzType="clock-circle"
           nzTheme="outline"></i>
      </button> -->

      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="safety"
           nzTheme="outline"></i>
        Generate me a random agent with a web application
      </button>

      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="alert"
           nzTheme="outline"></i>
        Customer Relationship Agent
      </button>

      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="file-text"
           nzTheme="outline"></i>
        Registration Agent
      </button>

      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="line-chart"
           nzTheme="outline"></i>
        Reporting Agent
      </button>

      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="schedule"
           nzTheme="outline"></i>
        Scheduling Agent
      </button>


      <button nz-button
              class="option-button">
        <i nz-icon
           nzType="schedule"
           nzTheme="outline"></i>
        A blank canvas
      </button>

    </div>
  </div>
</div>
